<template>
  <div>
    <!-- 宇视 -->
    <YSPlayer
      v-if="manufacturerCode === 'UniView'"
      :code="code"
      :showControlPanel="showControlPanel"
      :pIid="pIid"
    ></YSPlayer>
    <!-- 海康 -->
    <HKPlayer
      v-if="manufacturerCode === 'Hik'"
      :codeData="codeData"
      :showControlling="showControlPanel"
      :playerConfig="playerConfig"
    ></HKPlayer>
    <!-- 大华 -->
    <DaHuaPlayer
      v-if="manufacturerCode === 'DaHua'"
      :daHuaParams="daHuaParams"
      :showControlPanel="showControlPanel"
    >
    </DaHuaPlayer>
  </div>
</template>

<script>
import YSPlayer from './YSPlayer/YSPlayerControl'
import HKPlayer from './HKPlayer/index'
import DaHuaPlayer from './DaHuaPlayer/index'

export default {
  props: {
    // 摄像头编码
    code: {
      type: String,
      defalut: '',
    },
    // 摄像头名称
    name: {
      type: String,
      default: '',
    },
    // 是否显示云台操作
    showControlPanel: {
      type: Boolean,
      default: true,
    },
    pIid: {
      type: String,
      defalut: '',
    },
    manufacturerCode: {
      type: String,
      defalut: '',
    },
    daHuaParams: {
      type: Object,
      default: () => {},
    },
  },
  components: {
    YSPlayer,
    HKPlayer,
    DaHuaPlayer,
  },
  data() {
    return {
      loading: false,
      // 海康视频配置
      playerConfig: {
        streamType: 0, // 码流类型：0-主码流，1-子码流，2-第三码流，默认0
        protocol: '', // 取流协议('hik, rtsp, rtmp, hls')，默认hik
        transmode: 1, // 传输协议，0-UDP, 1-TCP, 默认TCP
        recordLocation: 1, // 存储类型：0-中心存储，1-设备存储，默认0
      },
      codeData: {
        code: '',
        id: 'hikplayer',
      },
    }
  },
  watch: {
    code: {
      immediate: true,
      handler(val) {
        this.codeData.code = val
        this.getProtocol()
      },
    },
  },
  created() {},
  methods: {
    // 获取使用协议
    getProtocol() {
      const protocol = window.location.protocol
      if (protocol === 'https:') {
        this.playerConfig.protocol = 'wss'
      } else if (protocol === 'http:') {
        this.playerConfig.protocol = 'ws'
      }
    },
  },
}
</script>

<style lang="scss" scoped>
::v-deep .el-dialog {
  background: rgba(16, 58, 68, 0.6980392157) !important;
  border: 1px solid rgba(68, 241, 255, 0.2980392157) !important;

  .el-dialog__header {
    border-color: rgba(68, 241, 255, 0.2980392157) !important;
    .el-dialog__title {
      color: white !important;
    }
    .el-dialog__headerbtn .el-dialog__close {
      color: #fff !important;
    }
  }
  .el-dialog__body {
    color: white !important;
  }
}
::v-deep .el-switch__label {
  color: #fff !important;
}
::v-deep .el-switch__label.is-active {
  color: #409eff !important;
}
.el-date-editor .el-range-input,
.el-date-editor .el-range-separator {
  background-color: transparent !important;
  color: #fff;
}

/* el-input */
::v-deep .el-input__inner {
  border-color: #d1e6ff;
  background-color: transparent;
  color: #fff;
  &:hover {
    border-color: #2b95e5;
  }
}

::v-deep .el-button--default {
  background-color: transparent;
  color: #fff;
}
::v-deep .el-range-editor.is-active,
::v-deep .el-range-editor.is-active:hover,
::v-deep .el-select .el-input.is-focus .el-input__inner {
  border-color: #fff;
}
::v-deep .el-input__inner:hover {
  border: 1px solid #0082ff;
}
::v-deep .el-button.is-plain:focus,
::v-deep .el-button.is-plain:hover {
  background-color: transparent;
  border-color: #0082ff;
  color: #0082ff;
}
::v-deep .el-range-editor.is-active,
::v-deep .el-range-editor.is-active:hover,
::v-deep .el-select .el-input.is-focus .el-input__inner {
  border-color: #0082ff;
}
::v-deep .el-switch.is-checked .el-switch__core {
  background-color: #0082ff;
  border-color: #0082ff;
}
::v-deep .el-date-editor .el-range-input,
::v-deep .el-date-editor .el-range-separator {
  background-color: transparent;
  color: #fff;
}
</style>
